import { render, staticRenderFns } from "./EventAdminCategories.vue?vue&type=template&id=4b6b4a20"
import script from "./EventAdminCategories.js?vue&type=script&lang=js&external"
export * from "./EventAdminCategories.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports